<app-page-detail [id]="id" [crud]="service" [(model)]="model" [(form)]="form" [reload]="reload" (modelChange)="checkModel()">
  <div header class="p-2 w-12 flex justify-content-center">
    <app-punto-campionamento-card [puntoCampionamento]="model()"></app-punto-campionamento-card>
    <div class="flex flex-column align-items-center justify-content-center border-1 surface-border border-round px-2 py-1 bg-white">
      <div class="text-sm text-700 font-light">
        Errori
      </div>
      <div *ngIf="form.valid" class="text-sm text-700 font-light">
        il form è valido: 

        <mat-icon  class="mat-mdc-tooltip-trigger text-green-400 material-symbols-outlined" style="position: relative; top:7px">check</mat-icon>
    
    </div>
      <div *ngIf="!form.valid && this.errorMessage" class="text-sm text-700 font-light">
          il form non è valido, dettaglio degli errori: 

            <mat-icon  class="mat-mdc-tooltip-trigger text-red-400 material-symbols-outlined" style="position: relative; top:7px;cursor: pointer;" (click)="showDialog()">error</mat-icon>
      
      </div>
    </div>

    <div class="flex flex-column align-items-center justify-content-center border-1 surface-border border-round px-2 py-1 bg-white">
      <div *ngIf="!checkisWithinIstatComune" class="text-sm text-700 font-light">
        <div class="text-sm text-700 font-light  text-center">
          Il Punto di Campionamento
        </div> 
        
       rientra nel territorio del comune indicato <mat-icon  class="mat-mdc-tooltip-trigger text-green-400 material-symbols-outlined" style="position: relative; top:7px">check</mat-icon>
      </div>

      <div *ngIf="checkisWithinIstatComune" class="text-sm text-700 font-light">
        <div class="text-sm text-700 font-light text-center">
          Il Punto di Campionamento
        </div>  
        non rientra nel territorio del comune indicato  <mat-icon  class="mat-mdc-tooltip-trigger text-red-400 material-symbols-outlined" style="position: relative; top:7px;cursor: pointer;" (click)="showDialog()">error</mat-icon>
      </div>
    </div>
  </div>
  <div class="grid mx-2 mt-1">
    <app-editable-card [IsModifyClickable]="model()?.isDateValid!" title="Id. ARERA" [form]="form" [crud]="service" [modelId]="model()?.uuid ?? '---'" [(model)]="model" class="col-12 md:col-6 lg:col-4">
      <app-text-field label="ATO" [value]="model()?.areraAto?.ato + ' (' + model()?.idAreraAto + ')'"></app-text-field>
      <app-text-field label="Gestore" [value]="model()?.areraGestore?.denominazione + ' (' + model()?.idAreraGestore + ')'"></app-text-field>
      <div card-form>
        <app-arera-form [form]="form"></app-arera-form>
      </div>
    </app-editable-card>
    <app-editable-card [IsModifyClickable]="model()?.isDateValid!" title="Acquedotto" [form]="form" [crud]="service" [modelId]="model()?.uuid ?? '---'" [(model)]="model" class="col-12 md:col-6 lg:col-4">
      <app-text-field label="Water Supply Zone" [value]="model()?.wsz"></app-text-field>
      <app-text-field label="Codice Acquedotto" [value]="model()?.acquedotto"></app-text-field>
      <app-text-field label="Progressivo linea acquedottistica" [value]="model()?.progressivoLineAcquedottistica ?? '---'"></app-text-field>
      <div card-form>
        <app-acquedotto-form [model]="this.model()"   [form]="form"></app-acquedotto-form>
      </div>
    </app-editable-card>
    <app-editable-card [IsModifyClickable]="model()?.isDateValid!" title="Informazioni" [form]="form" [crud]="service" [modelId]="model()?.uuid ?? '---'" [(model)]="model" class="col-12 md:col-6 lg:col-4">
      <app-text-field label="Abitanti serviti" [value]="model()?.previsioneAbitantiServiti ?? '---'"></app-text-field>
      <app-text-field label="Portata" [value]="model()?.previsionePortata ?? '---'"></app-text-field>
      <app-text-field label="Descrizione" [value]="model()?.descrizionePunto ?? '---'"></app-text-field>
      <app-text-field label="Note" [value]="model()?.note ?? '---'"></app-text-field>
      <div card-form>
        <app-informazioni-form [form]="form"></app-informazioni-form>
      </div>
    </app-editable-card>
    <app-editable-card [IsModifyClickable]="model()?.isDateValid!" title="Controlli previsti" [form]="form" [crud]="service" [modelId]="model()?.uuid ?? '---'" [(model)]="model" class="col-12 md:col-6 lg:col-6">
      <div class="flex justify-content-around">
        <app-text-field label="Esterni" [value]="model()?.numeroCampionamentoAnnuoEsterniPrevisto ?? '---'"></app-text-field>
        <app-text-field label="Interni" [value]="model()?.numeroCampionamentoAnnuoInternoPrevisto ?? '---'"></app-text-field>
      </div>

      <div style="overflow-x: scroll;overflow-y: scroll; max-height: 40vh;"  id="print-section"> 
      <app-table *ngIf="datiControlli; else noData" matSort [data]="datiControlli"
      [columns]="columnsControlli" 
      [crud]="controlloDettaglioService"
      insertFormSize="full" 
      insertFormTitle="Controlli"
      >
      <ng-content></ng-content>
  
    </app-table>
    <ng-template #noData>
      Nessun Dato da Visualizzare
    </ng-template>
  </div>
  <br>
  <div class="flex justify-content-end">
    <button  *ngIf="checkPrint" mat-flat-button  [useExistingCss]="true" printSectionId="print-section" ngxPrint color="primary" style="margin-right: 5px;">Stampa</button>
  </div>

   <!--    <div> 
        <a style="color:#000; text-decoration: none; cursor:pointer" (click)="showDialogControlli()">
          <mat-icon  class="mat-mdc-tooltip-trigger material-symbols-outlined" style="position: relative; top:7px">info</mat-icon>  
          Visualizza Dettaglio dei controlli
        </a>
      </div> -->
      <div card-form>
        <app-controlli-form [form]="form"></app-controlli-form>
      </div>
    </app-editable-card>
    <!--prova-->
    <app-card title="Storico" class="col-12 md:col-6 lg:col-6  ">
      <div style="overflow-y: scroll;max-height: 50vh;">
        <app-page-list 
         *ngIf="model()"
         [canSearch]="false"
         [columns]="columnsDatiStorico"
         [queryService]="serviceStorico.query"
         [canInsert]="false" 
         [crud]="service"
         [insertForm]="insertForm" 
         insertFormTitle="Storico" 
         insertFormSize="full"
         [canShowBreadcrumb]="false"
         [visibleColumns]="visibleColumns"
         >

        </app-page-list>

      </div>

    </app-card>
    <!--prova-->
    <app-editable-card  title="Posizione geografica" [form]="form" [crud]="service" [modelId]="model()?.uuid ?? '---'" [(model)]="model" class="col-12 md:col-12 lg:col-12" [IsModifyClickable]="false" [customActionClick]="customActionClick">
      <app-maps-field  [value]="model()?.coordinateMaps" [shapeComune]="shapeComune"></app-maps-field>
      <div card-form>
        <app-posizione-geografica-form [form]="form"></app-posizione-geografica-form>
      </div>
    </app-editable-card>
  </div>
</app-page-detail>
